function insideChatTypingTarget(el) {
  if (!el || !el.tagName) return false;
  const tag = String(el.tagName).toLowerCase();
  if (tag === 'textarea' || tag === 'input' || tag === 'select') return true;
  return !!el.isContentEditable;
}

/** True when n should open the new-chat search. A text field keeps the letter. */
function insideChatNewHeadHotkey(event, activeElement) {
  if (!event || event.repeat || event.isComposing) return false;
  if (event.ctrlKey || event.metaKey || event.altKey) return false;
  if (String(event.key || '').toLowerCase() !== 'n') return false;
  if (insideChatTypingTarget(event.target)) return false;
  if (insideChatTypingTarget(activeElement)) return false;
  return true;
}

module.exports = {
  insideChatTypingTarget,
  insideChatNewHeadHotkey,
};
